module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 no-widget-padding"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.widget.imageUrl,
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b875b69","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/page/widgets/FullSizeImageWidget.vue
// module id = 113
// module chunks = 0 1 2